import React, {useMemo} from "react";
import {Button, Modal, Stack} from "rsuite";

const ReportingHitDetailModal = (props) => {
    const { handleClose, open, userHit } = props;

    return useMemo(() => {
            return (
                <Modal
                    backdrop="static"
                    open={open}
                    onClose={handleClose}
                    keyboard={false}
                    size="sm"
                >
                    <Modal.Body>
                        <Stack spacing={20} direction='column' alignItems='flex-start'>
                            <h3>{userHit.firstName} {userHit.lastName}</h3>
                            <p>Match(es):</p>
                            {userHit.matchingContent?.split('\n').map((hit) => {
                                return <p>{hit}</p>;
                            })}
                        </Stack>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleClose} appearance="primary">
                            Ok
                        </Button>
                    </Modal.Footer>
                </Modal>
            );
        }, [handleClose, open, userHit]
    );
};

export default ReportingHitDetailModal;